<template>
  <div class="text-xs-center">
    <v-dialog full-width :value="values.showDialog" @input="(val) => { $store.commit('dialogPlan/change_values', {
          showDialog: val
        }) }" width="450px">
      <v-card>
        <v-card-title primary-title>
          <span class="headline">{{this.values.title}}</span>
          <v-btn icon style="right: 0; position: absolute" slot="activator" fab @click="closeDialog()">
            <v-icon color="#444">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div v-html="values.text"></div>
          <!-- <iframe v-if="dialogNotepadTask" width="100%" height="320px" src="https://www.youtube.com/embed/uR1A3c73lNg" allowfullscreen> -->
          <!-- </iframe> -->
          <div align="center">
            <img src="https://app.api.illis.com.br/images/file-limit.png" width="250px" height="250px">
          </div>
          <!-- <iframe v-if="values.showDialog" width="100%" height="320px" src="https://www.youtube.com/embed/uR1A3c73lNg" allowfullscreen> -->
          <!-- </iframe> -->
           <v-flex xs12 align="center">
            <v-btn block outline @click="upgradeClick" large color="#ffc107">
              <img src="https://img.icons8.com/color/48/000000/fairytale.png" height="30px"> &nbsp; Fazer Upgrade
            </v-btn>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
  export default {
    name: 'dialogPlan',
    data: function () {
      return {
        dialogOpen: false
      }
    },
    methods: {
      closeDialog () {
        this.$store.commit('dialogPlan/change_values', {
          showDialog: false
        })
      },
      upgradeClick () {
        this.closeDialog()
        this.$router.push(`/upgrade`)
      }
    },
    computed: {
      values () {
        return this.$store.getters[`dialogPlan/values`] || ''
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PDialogPlan.vue